<!--回访记录详情-->
<template>
    <div>
      <el-drawer @reload="$reloadHandle" title="回访记录详情" size="75%" :before-close="handleClose" :visible.sync="drawer"
        direction="rtl" append-to-body custom-class="demo-drawer" ref="drawer" class="details2">
        <div class="demo-drawer__content">
          <template>
            <div>
              <!-- 服务商 -->
              <div class="detail-wrap">
                <el-form ref="editForm" :model="formData">
                  <div class="d-header">
                    <div class="" style="padding: 5px;border-bottom: 1px solid #ededed">
                      回访单号：<span style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{ this.orderNo }}</span>
                      <!-- 回访状态 -->
                      <span class="information" v-if="formData.finishRecall == 0"><span class="btn_f">未回访</span></span>
                      <span class="information" v-else-if="formData.finishRecall == 1"><span
                          class="btn_t">回访失败</span></span>
                      <span class="information" v-else-if="formData.finishRecall == 5">回访成功</span>
                      <span v-else></span>
                    </div>
                  </div>
                  <div class="d-cont edit-mce-box">
                    <div class="d-item">
                      <div class="title first">
                        <b><span>记录详情</span></b>
                      </div>
                      <table class="table-detail">
                        <tbody>

                          <tr style="display: block;">
                            <th>回访员：</th>
                            <td>{{ formData.recallMan }}</td>
                            <th>回访员工号：</th>
                            <td v-if="formData.recallerNumber">{{ formData.recallerNumber }}</td>
                            <td v-else>{{ formData.recallMan }}</td>
                            <th>实际回访时间：</th>
                            <td>{{ formData.recallDate }}</td>

                            <th>回访情况：</th>

                            <td v-if="formData.huiFangQingKuang == 1"><span class="btn_t">属实</span></td>
                            <td v-else-if="formData.huiFangQingKuang == 2"><span class="btn_f">不属实</span></td>
                            <td v-else-if="formData.huiFangQingKuang == 3"><span class="btn_f">无果</span></td>
                            <td v-else></td>
                          </tr>
                          <tr style="display: block;">
                            <th>总体满意情况：</th>
                            <td v-if="formData.manYi == 1"><span class="btn_t">非常满意</span></td>
                            <td v-else-if="formData.manYi == 2"><span class="btn_t">满意</span></td>
                            <td v-else-if="formData.manYi == 3"><span class="btn_f">一般</span></td>
                            <td v-else-if="formData.manYi == 4"><span class="btn_f">不满意</span></td>
                            <td v-else-if="formData.manYi == 5"><span class="btn_f">非常不满意</span></td>
                            <td v-else-if="formData.manYi == 6"><span class="btn_f">未评价</span></td>
                            <td v-else></td>

                            <th>呼出结果：</th>
                            <!-- <td v-if="!formData.callResult"><span class="btn_t">正常呼出</span></td> -->
                            <td v-if="formData.callResult == 1"><span class="btn_t">正常呼出</span></td>
                            <td v-else-if="formData.callResult == 2"><span class="btn_t">无应答</span></td>
                            <td v-else-if="formData.callResult == 3"><span class="btn_f">拒访</span></td>
                            <td v-else-if="formData.callResult == 4"><span class="btn_f">空号</span></td>
                            <td v-else-if="formData.callResult == 5"><span class="btn_f">号码错误</span></td>
                            <td v-else-if="formData.callResult == 19"><span class="btn_t">其他</span></td>
                            <td v-else-if="formData.callResult == 6"><span class="btn_t">不清楚</span></td>
                            <td v-else></td>
                            <th>不属实原因：</th>
                            <td>
                              {{ formData.notTrueReasonName }}
                            </td>

                            <th>无果原因：</th>
                            <td>
                              {{ formData.noResultReasonName }}
                            </td>
                          </tr>


                          <tr style="display: block;" v-if="formData.unSatisfiedReasonName">
                            <th>不满意原因：</th>
                            <td colspan="7">
                              {{ formData.unSatisfiedReasonName }}
                            </td>
                          </tr>
                          <tr style="display: block;" v-if="formData.unSatisfiedRemark">
                            <th>不满意描述：</th>
                            <td colspan="7">{{ formData.unSatisfiedRemark }}</td>
                          </tr>

                          <tr style="display: block;">
                            <th>权益回访情况：</th>

                            <td v-if="formData.rightHuiFangQingKuang == 1"><span class="btn_t">属实</span></td>
                            <td v-else-if="formData.rightHuiFangQingKuang == 2"><span class="btn_f">不属实</span></td>
                            <td v-else-if="formData.rightHuiFangQingKuang == 3"><span class="btn_f">无果</span></td>
                            <td v-else></td>
                            <th>权益不属实原因：</th>
                            <td>
                              {{ formData.rightNotTrueReasonName }}
                            </td>

                            <th>权益无果原因：</th>
                            <td>
                              {{ formData.rightNoResultReasonName }}
                            </td>
                          </tr>

                          <tr style="display: block;">
                            <th>回访备注：</th>
                            <td colspan="7">
                              {{ formData.recallRemark }}
                            </td>
                          </tr>

                          <tr style="display: block;">
                            <th>推荐值：</th>
                            <td colspan="7">
                              {{ formData.recommendValue }}
                            </td>
                          </tr>
                          <tr style="display: block;">
                            <th>评价备注：</th>
                            <td colspan="7">
                              {{ formData.evaluateRemark }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div style="height: 10px;"></div>
                  </div>

                </el-form>
              </div>
            </div>
          </template>

        </div>
      </el-drawer>
    </div>
  </template>
  <script>
  import api from "@/api/projectApi";
  export default {
    inject: ['reload'],
    name: 'detailDialog',
    props: ['multi', 'row1', 'workNumber'],
    components: {
    },
    created() {
      this.formData = this.row1
      this.orderNo = this.workNumber
      console.log(this.formData, this.orderNo, "传过来的值");
    },
    data() {
      return {
        orderNo: '',
        dataId: {},
        drawer: true,
        formData: {},
      }
    },
    mounted() {
      // this.getData();
      // console.log(this.dataId, "_dataId的值");
    },
    methods: {
      // getData() {
      //   if (this.dataId && !isNaN(this.dataId)) {
      //     this.$http({
      //       url: api.soOrder.getDataUrl,
      //       method: 'post',
      //       data: {
      //         id: this.dataId
      //       },
      //       isLoading: true,
      //       modalStrictly: true,
      //     }).then(response => {
      //       this.formData = response.data.data

      //     })


      //   }
      // },
      confirm() {
        this.drawer = false;
        this.handleClose()
      },
      cancelForm() {
        this.drawer = false;
        clearTimeout(this.timer);
      },
      handleClose() {

        this.drawer = false;
        this.$emit('closeD', false)
      }
    }
  }
  </script>
  <style lang="scss" scoped>
  .details2 {

    ::v-deep .el-drawer .el-drawer__body {
      padding: 0 16px;
      background-color: #fff;
      position: relative;
    }

    ::v-deep .el-drawer .el-drawer__header {
      background-color: #fff;
    }

    ::v-deep .el-drawer__container {
      position: relative;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      height: 100%;
      width: 100%;
      background: aliceblue;
      background-color: rgb(38 38 38 / 70%);
    }

    #containt .table-detail {
      border-collapse: collapse;
      font-size: 12px;
      border: 1px solid #ededed;
    }

    .btn {
      text-align: center;
    }

    //   3个标签
    .information {
      padding: 2px 10px;
      background-color: #E1F2FF;
      color: #268AEA;
      border-radius: 3px;
      margin: 0 5px;
      font-size: 15px;
    }

    //   每个分支
    .d-item {
      border: 1px solid #ededed;
      padding-bottom: 5px;

      .title b {
        display: inline-block;
        line-height: 20px;
        font-size: 13px;
        font-weight: 600;
        margin-right: 84px;
        vertical-align: middle;
        color: rgb(42, 100, 148);
        position: relative;
        z-index: 2;
        background: rgba(42, 100, 148, 0.16);
        margin-left: 0px;
        margin-bottom: 8px;
        padding-left: 12px;
        padding-right: 14px;
        border-radius: 0px 28px 28px 0px;
      }

      .table-detail tr {
        margin-bottom: 20px;
        display: block;

        th {
          font-weight: 400;
          text-align: right;
          width: 7vw !important;
          font-size: 12px;
          position: relative;
          padding: 0 5px 0 4px;
          color: rgba(86, 86, 86, 0.96);
        }

        td {
          font-weight: 400;
          // text-align: right;
          width: 10vw !important;
          font-size: 12px;
          position: relative;
          padding: 0 0px 0 4px;
          color: rgba(0, 0, 0, );
        }
      }
    }

    ::v-deep .el-image__preview {
      width: 60px !important;
      height: 60px !important;
    }

    .pic_main {
      display: flex;
      margin-left: 20px;
      margin-top: 10px;

      .pic_item {
        display: flex;
        margin-right: 40px;

        span {
          white-space: nowrap;
          line-height: 60px;
          font-size: 12px;
          color: rgba(86, 86, 86, 0.96);
          font-weight: 400;

        }
      }
    }

    // 本单费用位置
    .expense {
      position: absolute;
      // right: 20%;
      left: 13vw;
      margin-top: 5px;
      color: #00c4b3;
      font-size: 13px;
    }

    // 滚动条样式

    /* 滚动条 */
    ::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }

    /* 滚动槽 */
    ::-webkit-scrollbar-track {
      border-radius: 0px;
      // background: rgba(224, 7, 7, 0.05);
    }

    /* 滚动条滑块 */
    ::-webkit-scrollbar-thumb {
      border-radius: 00px;
      background: #cfcece;
    }

    // 步骤条 圆的位置
    ::v-deep .el-timeline-item__node--normal {
      left: 0px !important;
      width: 12px;
      height: 12px;
    }

    ::v-deep .el-step__title {
      font-size: 13px !important;
      line-height: 38px;
    }
  }

  .Instructions {
    text-decoration: underline;
    color: #00c4b3;
    margin-left: 5px;
  }

  ::v-deep .el-radio {
    width: 65px;
  }

  .el-cascader-panel {
    .el-radio__inner {
      border: 0px;
      background: transparent;
    }

    .el-radio__input.is-checked .el-radio__inner {
      background: none;
    }


  }
  </style>
